<template>
  <div class="h-100 w-100">
    <div class="cam-container w-100 mx-auto mb-1">
      <div class="cam-container-inner">
        <cam-slot
          v-if="dataMatch.camera_data"
          :data="dataMatch.camera_data"
          :type="cam_type"
          :config="{ layout: 'alarm', synced: false }"
        />
      </div>
    </div>
    <div class="w-100 mx-auto">
      <div class="row">
        <div class="col-12 mb-2">
          <vueper-slides fixed-height="240px" :touchable="false">
            <vueper-slide v-for="(value, key) in dataMatch.media" :key="`slide-${key}`">
              <template #content>
                <div class="image-overlay-container">
                  <div class="overlay-content">
                    <div class="overlay-header">
                      <span class="camera-name">{{ dataMatch.camera_name }}</span>
                      <span class="date-stamp">{{
                        formatDateAssigned(dataMatch.created_at)
                      }}</span>
                    </div>

                    <div class="overlay-footer">
                      <span class="priority-label">{{ dataMatch.priority }}</span>
                    </div>
                  </div>
                  <img
                    class="img-thumbnail-vueper"
                    alt=""
                    :src="value.url"
                    @click="openImageModal(value.url)"
                    v-b-modal.image_modal
                  />
                </div>
              </template>
            </vueper-slide>
          </vueper-slides>
        </div>
      </div>
    </div>
    <table class="table table-sm" v-if="dataMatch">
      <tr>
        <th>{{ $t("grid.slots.info.analytic_record.alarm_category") }}</th>
        <td>{{ dataMatch.alarm_category }}</td>
      </tr>
      <tr>
        <th>{{ $t("alarm.alarm_type") }}</th>
        <td>{{ dataMatch.type_alarm }}</td>
      </tr>
      <tr>
        <th class="text-capitalize">{{ $t("date.created_at") }}</th>
        <td>{{ formatDateAssigned(dataMatch.created_at) }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.analytic_record.matched_rules") }}</th>
        <td>{{ dataMatch.matched_rules }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import moment from "moment-timezone";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import store from "@/store";
import CamSlot from "../../CamSlot.vue";

export default {
  components: {
    BButton,
    VueperSlides,
    VueperSlide,
    CamSlot,
  },
  props: {
    dataMatch: Object,
  },
  data() {
    return {
      cam_type: "cam_pa",
    };
  },
  methods: {
    formatPercentages(num) {
      return `${(parseFloat(num) * 100).toFixed(2)} %`;
    },
    formatNum(num, decimals = 0) {
      return parseFloat(num).toFixed(decimals);
    },
    formatDateAssigned(value) {
      const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return formattedDate;
    },
    async openImageModal(imageUrl) {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    },
  },
};
</script>

<style>
.image-overlay-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.overlay-content {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.overlay-header {
  color: white;
  width: 100%;
  background-color: rgba(0, 0, 0, 0) !important;
  text-shadow: 1px 2px #000;
  padding: 0.5rem;
  top: 0;
  background: linear-gradient(0deg, transparent 0%, rgba(0, 0, 0, 0.5) 95%);
}

.camera-name {
  display: block;
}

.date-stamp {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
}

.overlay-footer {
  position: absolute;
  color: white;
  width: 100%;
  background-color: rgba(0, 0, 0, 0) !important;
  text-shadow: 1px 2px #000;
  padding: 0.5rem;
  bottom: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
}

.priority-label {
  bottom: 0;
}

.cam-container-inner {
  width: 100%;
  height: 100%;
}

.cam-container {
  height: 16rem;
  position: relative;
}

.image-overlay-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
}

.img-thumbnail-vueper {
  height: 100%;
  object-fit: cover;
}
</style>
